import { useEffect } from 'react';
import { Font } from '../constants';
import { AVAILABLE_FONTS, getGoogleFontUrl } from '../utils/fontHelpers';

export function useSiteFonts(font: Font = Font.inter) {
  useEffect(() => {
    // Find the font configuration
    const fontInfo = AVAILABLE_FONTS.find((f) => f.value === font);
    if (!fontInfo) {
      console.warn(`Font "${font}" not found in AVAILABLE_FONTS`);
      return;
    }

    // 1. Generate a unique ID based on the font name
    // This ensures we don't overwrite the previous font's link tag
    const linkId = `font-link-${fontInfo.name.replace(/\s+/g, '-').toLowerCase()}`;

    // 2. Check if we have ALREADY loaded this specific font
    const isLoaded = document.getElementById(linkId);

    if (!isLoaded) {
      // If not found in DOM, generate the URL and append a NEW link tag
      const fontUrl = getGoogleFontUrl(fontInfo.name, fontInfo.hasItalics);

      const linkElement = document.createElement('link');
      linkElement.id = linkId;
      linkElement.rel = 'stylesheet';
      linkElement.href = fontUrl;

      document.head.appendChild(linkElement);
    }

    // 3. Update CSS variable to switch the active font
    // We do this regardless of whether we just fetched it or if it was already cached
    const fontStack = `'${fontInfo.name}', ${fontInfo.category}, system-ui`;
    document.body.style.setProperty('--font-main', fontStack);

    return () => {
      // We purposefully DO NOT remove the link tag on cleanup.
      // This keeps the font cached in the DOM for instant switching if the user comes back to it.
    };
  }, [font]);
}
